import React from "react";

const LOGO_URL =
  "https://customer-assets.emergentagent.com/job_fuel-advisor-1/artifacts/2l3h07nq_Ricochet%20logo%202018%20crop.png";

// Real Ricochet Fuel Distributors logo. We keep `variant` for API parity
// (header vs. footer placement) but the file itself is the same artwork.
export const Logo = ({ variant = "dark", className = "", size = "default" }) => {
  const sizeClass =
    size === "lg"
      ? "h-20 sm:h-24"
      : size === "sm"
      ? "h-10"
      : "h-14 sm:h-16";

  return (
    <div
      className={`flex items-center ${className}`}
      data-testid="ricochet-logo"
      data-variant={variant}
    >
      <img
        src={LOGO_URL}
        alt="Ricochet Fuel Distributors, Inc. — We Keep You Moving!"
        className={`${sizeClass} w-auto select-none`}
        draggable={false}
      />
    </div>
  );
};

export default Logo;
